"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIAssistEntryHelper = void 0;
const assistant_component_types_1 = require("../types/assistant.component.types");
/**
 * Static helper class for creating AI Assistant entries
 */
class AIAssistEntryHelper {
    /**
     * Create a message entry with suggestions and knowledge actions
     */
    static createMessageEntry(text, suggestions = [], knowledgeResults = []) {
        const actions = [];
        // Add suggestion actions
        suggestions.forEach(suggestion => {
            actions.push({
                label: suggestion.title,
                context: assistant_component_types_1.AssistantActionContext.TEXT_INSERTION,
                params: {
                    offset: 0,
                    length: suggestion.suggestion.length,
                    text: suggestion.suggestion
                }
            });
        });
        // Add knowledge attachment actions
        knowledgeResults.forEach(knowledge => {
            actions.push({
                label: `${'ai.assist.attachKnowledge'.t()} ${knowledge.title}`,
                context: assistant_component_types_1.AssistantActionContext.KDB_ATTACHMENT,
                params: this.processDBEntry(knowledge)
            });
        });
        return {
            type: assistant_component_types_1.AssistantEntryType.MESSAGE,
            text: text,
            actions: actions.length > 0 ? actions : undefined,
            knowledge: knowledgeResults
        };
    }
    /**
     * Create a knowledge-only entry
     */
    static createKnowledgeEntry(knowledgeResults, contextText) {
        const knowledgeActions = knowledgeResults.map(knowledge => ({
            label: `${'ai.assist.attachKnowledge'.t()} ${knowledge.title}`,
            context: assistant_component_types_1.AssistantActionContext.KDB_ATTACHMENT,
            params: this.processDBEntry(knowledge)
        }));
        const text = contextText ||
            `${'ai.assist.knowledgeFound'.t()}: ${knowledgeResults.map(k => k.title).join(', ')}`;
        return {
            type: assistant_component_types_1.AssistantEntryType.MESSAGE,
            text: text,
            actions: knowledgeActions,
            knowledge: knowledgeResults
        };
    }
    static processDBEntry(knowledge) {
        return {
            kdbId: knowledge.id,
            title: knowledge.title,
            description: knowledge.description,
            file: knowledge.file
        };
    }
    /**
     * Create a status entry
     */
    static createStatusEntry(text) {
        return {
            type: assistant_component_types_1.AssistantEntryType.STATUS,
            text: text
        };
    }
    /**
     * Create an action entry
     */
    static createActionEntry(text, actions) {
        return {
            type: assistant_component_types_1.AssistantEntryType.ACTION,
            text: text,
            actions: actions
        };
    }
}
exports.AIAssistEntryHelper = AIAssistEntryHelper;
